import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PassLimit } from '../../models';

enum LimitState {
	OriginOnly = 'origin_only',
	DestinationOnly = 'destination_only',
	IsBlocked = 'is_blocked',
}

@Component({
	selector: 'sp-wil-help-icon',
	templateUrl: './wil-help-icon.component.html',
	styleUrls: ['./wil-help-icon.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WilHelpIconComponent implements OnChanges {
	@Input() roomPassLimit!: PassLimit;
	@Input() isBlocking: boolean | undefined;

	description = '';
	private state: LimitState | undefined;

	ngOnChanges(_: SimpleChanges): void {
		this.setState();
		this.setDescription();
	}

	private setState(): void {
		if (!this.roomPassLimit.max_passes_from_active) {
			this.state = LimitState.DestinationOnly;
			return;
		}

		// at this point, origin limit is active
		if (this.isBlocking) {
			this.state = LimitState.IsBlocked;
			return;
		}

		// at this point, origin limit is active, but it's not blocking
		this.state = LimitState.OriginOnly;
	}

	private setDescription(): void {
		const { from_count, max_passes_from } = this.roomPassLimit;
		const studentString = from_count === 1 ? 'student has a pass' : 'students have passes';
		if (this.state === LimitState.DestinationOnly) {
			this.description = `${from_count} ${studentString} from this room`;
			return;
		}

		this.description = `${from_count}/${max_passes_from} ${studentString} from this room`;
	}
}
